@file:OptIn(InternalResourceApi::class)

package chartsproject.app.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/chartsproject.app.generated.resources/"

@delegate:ResourceContentHash(-359_204_268)
public val Res.string.app_name: StringResource by lazy {
      StringResource("string:app_name", "app_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 24),
      ))
    }

@delegate:ResourceContentHash(2_520_111)
public val Res.string.bar_chart: StringResource by lazy {
      StringResource("string:bar_chart", "bar_chart", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35, 21),
      ))
    }

@delegate:ResourceContentHash(-1_221_129_702)
public val Res.string.bar_data_points: StringResource by lazy {
      StringResource("string:bar_data_points", "bar_data_points", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 119, 47),
      ))
    }

@delegate:ResourceContentHash(-1_006_863_214)
public val Res.string.bar_data_points_range: StringResource by lazy {
      StringResource("string:bar_data_points_range", "bar_data_points_range", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 57, 61),
      ))
    }

@delegate:ResourceContentHash(-605_905_374)
public val Res.string.bar_stacked_chart: StringResource by lazy {
      StringResource("string:bar_stacked_chart", "bar_stacked_chart", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 167, 41),
      ))
    }

@delegate:ResourceContentHash(2_111_655_811)
public val Res.string.cd_close_dialog: StringResource by lazy {
      StringResource("string:cd_close_dialog", "cd_close_dialog", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 209, 39),
      ))
    }

@delegate:ResourceContentHash(1_885_197_310)
public val Res.string.cd_close_settings: StringResource by lazy {
      StringResource("string:cd_close_settings", "cd_close_settings", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 249, 45),
      ))
    }

@delegate:ResourceContentHash(1_513_011_259)
public val Res.string.cd_hide_parameters: StringResource by lazy {
      StringResource("string:cd_hide_parameters", "cd_hide_parameters", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 295, 46),
      ))
    }

@delegate:ResourceContentHash(-507_690_378)
public val Res.string.cd_navigate_back: StringResource by lazy {
      StringResource("string:cd_navigate_back", "cd_navigate_back", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 342, 32),
      ))
    }

@delegate:ResourceContentHash(1_886_444_647)
public val Res.string.cd_open_settings: StringResource by lazy {
      StringResource("string:cd_open_settings", "cd_open_settings", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 375, 44),
      ))
    }

@delegate:ResourceContentHash(-1_573_909_759)
public val Res.string.cd_open_style_details: StringResource by lazy {
      StringResource("string:cd_open_style_details", "cd_open_style_details", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 420, 53),
      ))
    }

@delegate:ResourceContentHash(-821_830_830)
public val Res.string.cd_pause_live_updates: StringResource by lazy {
      StringResource("string:cd_pause_live_updates", "cd_pause_live_updates", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 474, 53),
      ))
    }

@delegate:ResourceContentHash(669_827_369)
public val Res.string.cd_play_live_updates: StringResource by lazy {
      StringResource("string:cd_play_live_updates", "cd_play_live_updates", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 528, 52),
      ))
    }

@delegate:ResourceContentHash(1_505_974_269)
public val Res.string.cd_refresh_data: StringResource by lazy {
      StringResource("string:cd_refresh_data", "cd_refresh_data", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 581, 39),
      ))
    }

@delegate:ResourceContentHash(-984_300_785)
public val Res.string.cd_regenerate_chart: StringResource by lazy {
      StringResource("string:cd_regenerate_chart", "cd_regenerate_chart", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 621, 51),
      ))
    }

@delegate:ResourceContentHash(1_685_346_227)
public val Res.string.cd_select_theme: StringResource by lazy {
      StringResource("string:cd_select_theme", "cd_select_theme", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 673, 47),
      ))
    }

@delegate:ResourceContentHash(-708_718_065)
public val Res.string.cd_show_parameters: StringResource by lazy {
      StringResource("string:cd_show_parameters", "cd_show_parameters", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 721, 46),
      ))
    }

@delegate:ResourceContentHash(-2_137_618_855)
public val Res.string.chart_aspect_ratio: StringResource by lazy {
      StringResource("string:chart_aspect_ratio", "chart_aspect_ratio", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 768, 42),
      ))
    }

@delegate:ResourceContentHash(2_378_192)
public val Res.string.chart_aspect_square: StringResource by lazy {
      StringResource("string:chart_aspect_square", "chart_aspect_square", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 811, 31),
      ))
    }

@delegate:ResourceContentHash(2_414_638)
public val Res.string.chart_aspect_tall: StringResource by lazy {
      StringResource("string:chart_aspect_tall", "chart_aspect_tall", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 843, 29),
      ))
    }

@delegate:ResourceContentHash(893_605_350)
public val Res.string.chart_aspect_wide: StringResource by lazy {
      StringResource("string:chart_aspect_wide", "chart_aspect_wide", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 873, 33),
      ))
    }

@delegate:ResourceContentHash(-492_944_298)
public val Res.string.chart_basic: StringResource by lazy {
      StringResource("string:chart_basic", "chart_basic", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 907, 27),
      ))
    }

@delegate:ResourceContentHash(29_589_604)
public val Res.string.chart_custom: StringResource by lazy {
      StringResource("string:chart_custom", "chart_custom", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 935, 28),
      ))
    }

@delegate:ResourceContentHash(-640_381_755)
public val Res.string.chart_default: StringResource by lazy {
      StringResource("string:chart_default", "chart_default", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 964, 33),
      ))
    }

@delegate:ResourceContentHash(1_906_250_625)
public val Res.string.chart_timeline: StringResource by lazy {
      StringResource("string:chart_timeline", "chart_timeline", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 998, 34),
      ))
    }

@delegate:ResourceContentHash(2_553_393)
public val Res.string.dark_mode_off: StringResource by lazy {
      StringResource("string:dark_mode_off", "dark_mode_off", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1033, 25),
      ))
    }

@delegate:ResourceContentHash(2_552_167)
public val Res.string.dark_mode_on: StringResource by lazy {
      StringResource("string:dark_mode_on", "dark_mode_on", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1059, 24),
      ))
    }

@delegate:ResourceContentHash(-959_261_427)
public val Res.string.dark_mode_system: StringResource by lazy {
      StringResource("string:dark_mode_system", "dark_mode_system", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1084, 32),
      ))
    }

@delegate:ResourceContentHash(-861_724_022)
public val Res.string.drawer_dark_mode_subtitle: StringResource by lazy {
      StringResource("string:drawer_dark_mode_subtitle", "drawer_dark_mode_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1117, 53),
      ))
    }

@delegate:ResourceContentHash(-1_811_490_972)
public val Res.string.drawer_dynamic_colors_disable_hint: StringResource by lazy {
      StringResource("string:drawer_dynamic_colors_disable_hint", "drawer_dynamic_colors_disable_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1171, 98),
      ))
    }

@delegate:ResourceContentHash(1_077_194_467)
public val Res.string.drawer_dynamic_colors_subtitle: StringResource by lazy {
      StringResource("string:drawer_dynamic_colors_subtitle", "drawer_dynamic_colors_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1270, 70),
      ))
    }

@delegate:ResourceContentHash(-75_263_042)
public val Res.string.drawer_github_subtitle: StringResource by lazy {
      StringResource("string:drawer_github_subtitle", "drawer_github_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1341, 74),
      ))
    }

@delegate:ResourceContentHash(1_752_823_957)
public val Res.string.drawer_header_subtitle: StringResource by lazy {
      StringResource("string:drawer_header_subtitle", "drawer_header_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1416, 62),
      ))
    }

@delegate:ResourceContentHash(2_128_440_428)
public val Res.string.drawer_header_title: StringResource by lazy {
      StringResource("string:drawer_header_title", "drawer_header_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1479, 39),
      ))
    }

@delegate:ResourceContentHash(54_228_438)
public val Res.string.drawer_section_appearance: StringResource by lazy {
      StringResource("string:drawer_section_appearance", "drawer_section_appearance", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1519, 49),
      ))
    }

@delegate:ResourceContentHash(-2_136_593_858)
public val Res.string.drawer_section_links: StringResource by lazy {
      StringResource("string:drawer_section_links", "drawer_section_links", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1569, 36),
      ))
    }

@delegate:ResourceContentHash(1_226_263_246)
public val Res.string.drawer_section_themes: StringResource by lazy {
      StringResource("string:drawer_section_themes", "drawer_section_themes", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1606, 37),
      ))
    }

@delegate:ResourceContentHash(1_997_915_644)
public val Res.string.drawer_title_dark_mode: StringResource by lazy {
      StringResource("string:drawer_title_dark_mode", "drawer_title_dark_mode", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1644, 42),
      ))
    }

@delegate:ResourceContentHash(-1_212_443_219)
public val Res.string.drawer_title_dynamic_colors: StringResource by lazy {
      StringResource("string:drawer_title_dynamic_colors", "drawer_title_dynamic_colors", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1687, 55),
      ))
    }

@delegate:ResourceContentHash(1_445_892_428)
public val Res.string.drawer_title_github: StringResource by lazy {
      StringResource("string:drawer_title_github", "drawer_title_github", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1743, 35),
      ))
    }

@delegate:ResourceContentHash(433_035_716)
public val Res.string.github_url: StringResource by lazy {
      StringResource("string:github_url", "github_url", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1842, 70),
      ))
    }

@delegate:ResourceContentHash(1_429_505_610)
public val Res.string.github_url_content_description: StringResource by lazy {
      StringResource("string:github_url_content_description", "github_url_content_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1779, 62),
      ))
    }

@delegate:ResourceContentHash(686_800_562)
public val Res.string.histogram_chart: StringResource by lazy {
      StringResource("string:histogram_chart", "histogram_chart", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1913, 35),
      ))
    }

@delegate:ResourceContentHash(-1_221_129_702)
public val Res.string.histogram_data_points: StringResource by lazy {
      StringResource("string:histogram_data_points", "histogram_data_points", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2017, 53),
      ))
    }

@delegate:ResourceContentHash(-1_006_863_214)
public val Res.string.histogram_data_points_range: StringResource by lazy {
      StringResource("string:histogram_data_points_range", "histogram_data_points_range", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1949, 67),
      ))
    }

@delegate:ResourceContentHash(-2_136_774_061)
public val Res.string.line_chart: StringResource by lazy {
      StringResource("string:line_chart", "line_chart", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2071, 26),
      ))
    }

@delegate:ResourceContentHash(-1_221_129_702)
public val Res.string.line_data_points: StringResource by lazy {
      StringResource("string:line_data_points", "line_data_points", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2161, 48),
      ))
    }

@delegate:ResourceContentHash(-1_006_863_214)
public val Res.string.line_data_points_range: StringResource by lazy {
      StringResource("string:line_data_points_range", "line_data_points_range", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2098, 62),
      ))
    }

@delegate:ResourceContentHash(2_086_110_003)
public val Res.string.multi_line_chart: StringResource by lazy {
      StringResource("string:multi_line_chart", "multi_line_chart", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2210, 40),
      ))
    }

@delegate:ResourceContentHash(2_603_922)
public val Res.string.pie_chart: StringResource by lazy {
      StringResource("string:pie_chart", "pie_chart", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2251, 21),
      ))
    }

@delegate:ResourceContentHash(-2_125_727_856)
public val Res.string.radar_chart: StringResource by lazy {
      StringResource("string:radar_chart", "radar_chart", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2273, 27),
      ))
    }

@delegate:ResourceContentHash(-606_510_358)
public val Res.string.stacked_area_chart: StringResource by lazy {
      StringResource("string:stacked_area_chart", "stacked_area_chart", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2301, 42),
      ))
    }

@delegate:ResourceContentHash(-1_221_129_702)
public val Res.string.stacked_area_data_points: StringResource by lazy {
      StringResource("string:stacked_area_data_points", "stacked_area_data_points", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2415, 56),
      ))
    }

@delegate:ResourceContentHash(-1_006_863_214)
public val Res.string.stacked_area_data_points_range: StringResource by lazy {
      StringResource("string:stacked_area_data_points_range", "stacked_area_data_points_range", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2344, 70),
      ))
    }

@delegate:ResourceContentHash(-1_221_129_702)
public val Res.string.stacked_bar_data_points: StringResource by lazy {
      StringResource("string:stacked_bar_data_points", "stacked_bar_data_points", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2542, 55),
      ))
    }

@delegate:ResourceContentHash(-1_006_863_214)
public val Res.string.stacked_bar_data_points_range: StringResource by lazy {
      StringResource("string:stacked_bar_data_points_range", "stacked_bar_data_points_range", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2472, 69),
      ))
    }

@delegate:ResourceContentHash(1_454_888_453)
public val Res.string.style_auto_generated_from_empty: StringResource by lazy {
      StringResource("string:style_auto_generated_from_empty", "style_auto_generated_from_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2598, 95),
      ))
    }

@delegate:ResourceContentHash(-1_767_401_970)
public val Res.string.style_fallback_name: StringResource by lazy {
      StringResource("string:style_fallback_name", "style_fallback_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2694, 35),
      ))
    }

@delegate:ResourceContentHash(350_736_062)
public val Res.string.style_name_custom: StringResource by lazy {
      StringResource("string:style_name_custom", "style_name_custom", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2730, 45),
      ))
    }

@delegate:ResourceContentHash(1_964_272_301)
public val Res.string.style_name_default: StringResource by lazy {
      StringResource("string:style_name_default", "style_name_default", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2776, 46),
      ))
    }

@delegate:ResourceContentHash(-553_430_825)
public val Res.string.style_status_count: StringResource by lazy {
      StringResource("string:style_status_count", "style_status_count", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2823, 34),
      ))
    }

@delegate:ResourceContentHash(-640_381_755)
public val Res.string.style_status_default: StringResource by lazy {
      StringResource("string:style_status_default", "style_status_default", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2858, 40),
      ))
    }

@delegate:ResourceContentHash(1_936_745_994)
public val Res.string.style_status_modified: StringResource by lazy {
      StringResource("string:style_status_modified", "style_status_modified", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2899, 41),
      ))
    }

@delegate:ResourceContentHash(1_026_840_033)
public val Res.string.style_status_unused: StringResource by lazy {
      StringResource("string:style_status_unused", "style_status_unused", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2941, 35),
      ))
    }

@delegate:ResourceContentHash(-160_393_620)
public val Res.string.style_unused_generic_usage: StringResource by lazy {
      StringResource("string:style_unused_generic_usage", "style_unused_generic_usage", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2977, 86),
      ))
    }

@delegate:ResourceContentHash(-1_599_454_291)
public val Res.string.style_unused_ignored_because_provided: StringResource by lazy {
      StringResource("string:style_unused_ignored_because_provided", "style_unused_ignored_because_provided", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3064, 97),
      ))
    }

@delegate:ResourceContentHash(993_147_717)
public val Res.string.style_unused_single_series_area_color: StringResource by lazy {
      StringResource("string:style_unused_single_series_area_color", "style_unused_single_series_area_color", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3162, 141),
      ))
    }

@delegate:ResourceContentHash(1_454_934_541)
public val Res.string.style_unused_single_series_line_color: StringResource by lazy {
      StringResource("string:style_unused_single_series_line_color", "style_unused_single_series_line_color", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3304, 141),
      ))
    }

@delegate:ResourceContentHash(-1_560_866_506)
public val Res.string.style_value_auto: StringResource by lazy {
      StringResource("string:style_value_auto", "style_value_auto", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3446, 32),
      ))
    }

@delegate:ResourceContentHash(-637_121_672)
public val Res.string.style_value_color: StringResource by lazy {
      StringResource("string:style_value_color", "style_value_color", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3528, 33),
      ))
    }

@delegate:ResourceContentHash(971_367_210)
public val Res.string.style_value_colors_count: StringResource by lazy {
      StringResource("string:style_value_colors_count", "style_value_colors_count", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3479, 48),
      ))
    }

@delegate:ResourceContentHash(29_589_604)
public val Res.string.style_value_custom: StringResource by lazy {
      StringResource("string:style_value_custom", "style_value_custom", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3562, 34),
      ))
    }

@delegate:ResourceContentHash(-640_381_755)
public val Res.string.style_value_default: StringResource by lazy {
      StringResource("string:style_value_default", "style_value_default", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3597, 39),
      ))
    }

@delegate:ResourceContentHash(1_962_339_924)
public val Res.string.themes_content_description: StringResource by lazy {
      StringResource("string:themes_content_description", "themes_content_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3637, 58),
      ))
    }

@delegate:ResourceContentHash(240_348_946)
public val Res.string.timeline_update_interval: StringResource by lazy {
      StringResource("string:timeline_update_interval", "timeline_update_interval", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3696, 64),
      ))
    }

@delegate:ResourceContentHash(518_593_909)
public val Res.string.timeline_window_size: StringResource by lazy {
      StringResource("string:timeline_window_size", "timeline_window_size", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3761, 60),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("app_name", Res.string.app_name)
  map.put("bar_chart", Res.string.bar_chart)
  map.put("bar_data_points", Res.string.bar_data_points)
  map.put("bar_data_points_range", Res.string.bar_data_points_range)
  map.put("bar_stacked_chart", Res.string.bar_stacked_chart)
  map.put("cd_close_dialog", Res.string.cd_close_dialog)
  map.put("cd_close_settings", Res.string.cd_close_settings)
  map.put("cd_hide_parameters", Res.string.cd_hide_parameters)
  map.put("cd_navigate_back", Res.string.cd_navigate_back)
  map.put("cd_open_settings", Res.string.cd_open_settings)
  map.put("cd_open_style_details", Res.string.cd_open_style_details)
  map.put("cd_pause_live_updates", Res.string.cd_pause_live_updates)
  map.put("cd_play_live_updates", Res.string.cd_play_live_updates)
  map.put("cd_refresh_data", Res.string.cd_refresh_data)
  map.put("cd_regenerate_chart", Res.string.cd_regenerate_chart)
  map.put("cd_select_theme", Res.string.cd_select_theme)
  map.put("cd_show_parameters", Res.string.cd_show_parameters)
  map.put("chart_aspect_ratio", Res.string.chart_aspect_ratio)
  map.put("chart_aspect_square", Res.string.chart_aspect_square)
  map.put("chart_aspect_tall", Res.string.chart_aspect_tall)
  map.put("chart_aspect_wide", Res.string.chart_aspect_wide)
  map.put("chart_basic", Res.string.chart_basic)
  map.put("chart_custom", Res.string.chart_custom)
  map.put("chart_default", Res.string.chart_default)
  map.put("chart_timeline", Res.string.chart_timeline)
  map.put("dark_mode_off", Res.string.dark_mode_off)
  map.put("dark_mode_on", Res.string.dark_mode_on)
  map.put("dark_mode_system", Res.string.dark_mode_system)
  map.put("drawer_dark_mode_subtitle", Res.string.drawer_dark_mode_subtitle)
  map.put("drawer_dynamic_colors_disable_hint", Res.string.drawer_dynamic_colors_disable_hint)
  map.put("drawer_dynamic_colors_subtitle", Res.string.drawer_dynamic_colors_subtitle)
  map.put("drawer_github_subtitle", Res.string.drawer_github_subtitle)
  map.put("drawer_header_subtitle", Res.string.drawer_header_subtitle)
  map.put("drawer_header_title", Res.string.drawer_header_title)
  map.put("drawer_section_appearance", Res.string.drawer_section_appearance)
  map.put("drawer_section_links", Res.string.drawer_section_links)
  map.put("drawer_section_themes", Res.string.drawer_section_themes)
  map.put("drawer_title_dark_mode", Res.string.drawer_title_dark_mode)
  map.put("drawer_title_dynamic_colors", Res.string.drawer_title_dynamic_colors)
  map.put("drawer_title_github", Res.string.drawer_title_github)
  map.put("github_url", Res.string.github_url)
  map.put("github_url_content_description", Res.string.github_url_content_description)
  map.put("histogram_chart", Res.string.histogram_chart)
  map.put("histogram_data_points", Res.string.histogram_data_points)
  map.put("histogram_data_points_range", Res.string.histogram_data_points_range)
  map.put("line_chart", Res.string.line_chart)
  map.put("line_data_points", Res.string.line_data_points)
  map.put("line_data_points_range", Res.string.line_data_points_range)
  map.put("multi_line_chart", Res.string.multi_line_chart)
  map.put("pie_chart", Res.string.pie_chart)
  map.put("radar_chart", Res.string.radar_chart)
  map.put("stacked_area_chart", Res.string.stacked_area_chart)
  map.put("stacked_area_data_points", Res.string.stacked_area_data_points)
  map.put("stacked_area_data_points_range", Res.string.stacked_area_data_points_range)
  map.put("stacked_bar_data_points", Res.string.stacked_bar_data_points)
  map.put("stacked_bar_data_points_range", Res.string.stacked_bar_data_points_range)
  map.put("style_auto_generated_from_empty", Res.string.style_auto_generated_from_empty)
  map.put("style_fallback_name", Res.string.style_fallback_name)
  map.put("style_name_custom", Res.string.style_name_custom)
  map.put("style_name_default", Res.string.style_name_default)
  map.put("style_status_count", Res.string.style_status_count)
  map.put("style_status_default", Res.string.style_status_default)
  map.put("style_status_modified", Res.string.style_status_modified)
  map.put("style_status_unused", Res.string.style_status_unused)
  map.put("style_unused_generic_usage", Res.string.style_unused_generic_usage)
  map.put("style_unused_ignored_because_provided", Res.string.style_unused_ignored_because_provided)
  map.put("style_unused_single_series_area_color", Res.string.style_unused_single_series_area_color)
  map.put("style_unused_single_series_line_color", Res.string.style_unused_single_series_line_color)
  map.put("style_value_auto", Res.string.style_value_auto)
  map.put("style_value_color", Res.string.style_value_color)
  map.put("style_value_colors_count", Res.string.style_value_colors_count)
  map.put("style_value_custom", Res.string.style_value_custom)
  map.put("style_value_default", Res.string.style_value_default)
  map.put("themes_content_description", Res.string.themes_content_description)
  map.put("timeline_update_interval", Res.string.timeline_update_interval)
  map.put("timeline_window_size", Res.string.timeline_window_size)
}
